import { render, staticRenderFns } from "./RefactorConfirmationModal.vue?vue&type=template&id=a4c6ae72"
import script from "./RefactorConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RefactorConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports